import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("click", this.removeElement.bind(this));
  }

  removeElement(e) {
    e.preventDefault();
    var elementId = this.element.attributes["data-element-id"].value;
    var element = document.getElementById(elementId);
    element.remove(); 
  }
}